<cx-icon
  *ngFor="let i of [1, 2, 3, 4, 5]"
  [type]="icon"
  class="star"
  [ngClass]="{ 'star--active': i <= rating }"
  (mouseover)="setRate(i)"
  (click)="saveRate(i)"
  (keydown.space)="saveRate(i)"
  [attr.tabindex]="disabled ? null : 0"
></cx-icon>
